import apiClient from '@disco/api/server'
import { createApi } from '@reduxjs/toolkit/query/react'
import type { Business } from 'types/business'

export const userBusinessesApi = createApi({
  reducerPath: 'userBusinesses',
  baseQuery: async () => {
    try {
      const response = await apiClient.fetchUserMemberships(true)

      return { data: response.results }
    } catch (error) {
      return { error }
    }
  },
  endpoints: build => ({
    getUserBusinesses: build.query<Business[], void>({
      query: () => '',
    }),
  }),
})
